














































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import {
	Org,
	Product,
	SimproApi,
	SimproJob,
	SimproJobDetails,
	SimproJobDetailsInData,
	SitesApi,
} from '../../api';
import SimproJobModal from '@/components/display/SimproJobModal.vue';
import TitleMixin from '@/mixins/title-mixin';
import { AxiosError, AxiosResponse } from 'axios';
import Toast from '@/components/display/toast.vue';
import { BvTableFieldArray } from 'bootstrap-vue';
import { ApiUtils } from '@/common/ApiUtils';
import { SimproService } from '@/services/simpro-service';

@Component({
	components: {
		SimproJobModal,
	},
	mixins: [TitleMixin],
})
export default class SimPro extends Vue {
	public smallScreen = window.innerWidth < 1000;

	@Prop(Number)
	public siteId?: number;

	@Prop(Object)
	public product?: Product;

	@Prop(Array)
	public simproJobs?: SimproJobDetails[];

	@Prop(Array)
	public partnerOrgs?: Org[];

	@Prop(Number)
	public orgId?: number;

	public site: any | null = null;
	public jobs: SimproJobDetails[] = [];
	public selectedJob: SimproJob | null = null;
	public selectedJobDetails: SimproJobDetails | null = null;

	public siteError: string | null = null;
	public expandError: boolean = false;

	public loadingJobs = true;

	public jobSortBy: string = 'id';
	public jobSortDesc = true;

	public jobFields: BvTableFieldArray = [
		{ key: 'id', label: 'Id', sortable: true },
		{
			key: 'description',
			label: 'Description',
			sortable: true,
		},
		{
			key: 'installer',
			label: 'Technician',
			sortable: false,
			formatter: (installerName: string | null) => installerName ?? 'No installer scheduled',
		},
		{
			key: 'installerScheduled',
			label: 'Installer Scheduled',
			sortable: false,
			formatter: (installerScheduled: string | null) =>
				Vue.filter('shortDateTime')(installerScheduled ?? ''),
		},
		{ key: 'status', label: 'Status', sortable: true },
		{ key: 'stage', label: 'Stage', sortable: true },
		{ key: 'dueDate', label: 'Due Date', sortable: true },
		{ key: 'createdAt', label: 'Created At', sortable: true },
		{ key: 'completedAt', label: 'Completed At', sortable: true },
	];

	private api: SitesApi = new SitesApi();
	private simproService: SimproService = new SimproService();

	@Watch('simproJobs')
	public simproJobsChanged() {
		this.jobs = this.simproJobs ?? [];
	}

	public async load() {
		if (this.simproJobs) {
			return;
		}
		this.loadingJobs = true;
		try {
			const { data } = await this.api.getSiteById(
				parseInt(this.product?.siteId ?? this.siteId, 10),
				{
					params: {
						include: 'simprojobs',
					},
				},
			);
			this.site = data;
			this.loadingJobs = true;

			this.jobs = await this.simproService.getSimproJobDetails(
				this.site.simprojobs,
				this.axios,
				this.product,
			);
			this.loadingJobs = false;
		} catch (e) {
			this.site = null;
			this.siteError = e;
			if (e.response && e.response.data && e.response.data.message) {
				this.siteError = e.response.data.message;
			}
		} finally {
			this.loading = false;
			if (this.jobs.some(j => j.stage !== 'Complete' && j.stage !== 'Archived')) {
				this.$emit('jobsExist');
			}
			if (this.jobs.some(j => j.stage === 'Pending')) {
				new Toast().makeToast(
					'There is a pending Job on this Product',
					'Pending Job on Product',
					'warning',
					false,
				);
			}
			this.onLoadedJobs();
		}
	}

	public openSimproJobModal(simproJobDetails: SimproJobDetails): void {
		this.selectedJob =
			this.site.simprojobs.find(
				(job: { simproJobId: number }) => job.simproJobId === simproJobDetails.id,
			) ?? null;
		this.selectedJobDetails = simproJobDetails;
		if (this.selectedJob !== null) {
			this.$bvModal.show('simproJobModal');
		}
	}

	public created() {
		this.load();
	}

	@Emit('loadedJobs')
	public onLoadedJobs(): SimproJobDetails[] {
		return this.jobs ?? [];
	}
}
